/**
 * Default Firebase configuration for the XRGallery cloud platform.
 * Used by create() when a sceneId is provided without an explicit firebaseConfig.
 * These are public client-side credentials (safe to expose).
 */

import type { FirebaseConfig } from '../services/interfaces';

export const DEFAULT_FIREBASE_CONFIG: FirebaseConfig = {
  apiKey: "AIzaSyC8fBDeIOH19O27vGcjqTu5WQcMpkzrIA8",
  authDomain: "webxrgallery.firebaseapp.com",
  projectId: "webxrgallery",
  storageBucket: "webxrgallery.firebasestorage.app",
  messagingSenderId: "517880920535",
  appId: "1:517880920535:web:5a4bbe3e8d33075a0f3392",
  measurementId: "G-7QKB4JCYEH",
};
